const actions = {
  CHECK_AUTHORIZATION: 'STD_CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'STD_LOGIN_REQUEST',
  LOGOUT: 'STD_LOGOUT',
  LOGIN_SUCCESS: 'STD_LOGIN_SUCCESS',
  LOGIN_ERROR: 'STD_LOGIN_ERROR',
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  signin: (token = false) => ({
    type: actions.LOGIN_REQUEST,
    payload: { token },
  }),
  signout: () => ({
    type: actions.LOGOUT,
  }),
};
export default actions;
